import { z } from 'zod'

import { commonCommentFilterSchema } from '@/constants/common-comment-filter-schema'

const studentsCommentFilterSchema = z.object({
  coursesId: z.array(z.string()).optional()
})

export const commentFilterSchema = studentsCommentFilterSchema.merge(
  commonCommentFilterSchema
)

export type CommentFiltersKeys = keyof z.infer<typeof commentFilterSchema>
